module.exports = __webpack_public_path__ + "img/bess_item.4d359274.svg";